import Share from '@/containers/share/Share';
import Binding from '@/containers/share/Binding';

import { ROUTE_SHARE_VIEW, ROUTE_SHARE_BINDING } from '@/router/names';
import { SCOPE_SNSAPI_BASE, SCOPE_SNSAPI_USERINFO } from '@/constants/wechat';

const createRoute = step => ({
    path: `/share/:hash/${step}`,
    name: `share.${step}`,
    component: Share,
    meta: {
        wechat_auth: SCOPE_SNSAPI_BASE,
        title: '分享',
    },
    props: {
        step,
    },
});
const createBindingRoute = step => ({
    path: `/share/:hash/${step}`,
    name: `share.${step}`,
    component: Binding,
    meta: {
        wechat_auth: SCOPE_SNSAPI_USERINFO,
        title: '绑定',
    },
    props: {
        step,
    },
});

export default [
    {
        path: '/share/:hash',
        name: ROUTE_SHARE_VIEW,
        component: Share,
        meta: {
            wechat_auth: SCOPE_SNSAPI_BASE,
            bridge: true,
        },
    },
    createRoute('course'),
    createRoute('unbound'),
    createRoute('times'),
    createRoute('start'),
    {
        path: '/share/:hash/binding',
        name: ROUTE_SHARE_BINDING,
        component: Binding,
        meta: {
            wechat_auth: SCOPE_SNSAPI_USERINFO,
            bridge: true,
        },
    },
    createBindingRoute('request'),
    createBindingRoute('qrcode'),
];



// WEBPACK FOOTER //
// ./src/router/share.js